import React from "react";

export default function Layout({ children }) {
	return (
		<div>
			{children}
		</div>
	);
}
